import { FC, useState } from "react";

import { LineStylePicker } from "./LineStylePicker";

import styles from "./styles/ToolSettingsModal.module.css";

interface Props {
  label: string;
  color: string;
  visible: boolean;
  onColorChange: (color: string) => void;
  onVisibleChange: (visible: boolean) => void;
}

export const ColorCheckRow: FC<Props> = ({
  label,
  color,
  visible,
  onColorChange,
  onVisibleChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className={styles.mainLineRow}>
        <span className={styles.mainLineLabel}>{label}</span>
        <div className={styles.rowActions}>
          <button
            className={styles.mainLineBtn}
            onClick={() => setIsOpen((v) => !v)}
          >
            <span
              className={styles.colorPreview}
              style={{ backgroundColor: color }}
            />
          </button>
          <button
            className={`${styles.checkbox} ${visible ? styles.checkboxChecked : ""}`}
            onClick={() => onVisibleChange(!visible)}
            aria-label={visible ? "Hide" : "Show"}
          />
        </div>
      </div>
      {isOpen && (
        <LineStylePicker
          value={{ color, opacity: 100 }}
          onChange={(v) => onColorChange(v.color)}
          showWidth={false}
          showOpacity={false}
        />
      )}
    </div>
  );
};
